export const MuiTypography = {
  styleOverrides: {
    paper: {
      borderRadius: '7px'
    },
    standard: {
      fontSize: '15px',
      lineHeight: '22.5px!important',
      fontWeight: 600
    },
    main: {
      fontSize: '22px',
      lineHeight: '30px!important',
      fontWeight: 700
    }
  }
}
